import { isString } from 'fp-ts/lib/string'

/**
 * Takes in any value and always returns a string.
 */
export function validateString<T>(str: T): string {
  return isString(str) ? str : ''
}
